if (!customElements.get('collection-products-carousel')) {

  class CollectionProductsCarousel extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initSwiper();
    }

    initSwiper() {
      const container = this.querySelector('.swiper'); 
      if (!container) return;

      const slides = container.querySelectorAll('.swiper-slide');
      const nextBtn = this.querySelector('.swiper-button-next');
      const prevBtn = this.querySelector('.swiper-button-prev');

      if (!slides.length) return;

      const totalSlides = slides.length;
      const maxSlidesPerView = 4;
      const slidesPerGroup = 1;

      const enableLoop = totalSlides >= maxSlidesPerView;

      this.swiper = new Swiper(container, {
        loop: enableLoop,
        loopAddBlankSlides: true,
        slidesPerView: 1,
        slidesPerGroup: slidesPerGroup,
        spaceBetween: 10,
        rewind: !enableLoop,
        
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
        },

        breakpoints: {
          576: { slidesPerView: 2, slidesPerGroup, spaceBetween: 10 },
          768: { slidesPerView: 3, slidesPerGroup, spaceBetween: 10 },
          1024: { slidesPerView: 3, slidesPerGroup, spaceBetween: 24 },
          1280: { slidesPerView: 4, slidesPerGroup, spaceBetween: 34 },
          1541: { slidesPerView: 4, slidesPerGroup, spaceBetween: 44 }
        }
      });
    }
  }

  customElements.define('collection-products-carousel', CollectionProductsCarousel);
}